import getQueryParam from './getQueryParam';

export default function getQuantityFromUrl() {
  return Number(getQueryParam('qty', 0));
}
